import clsx from 'clsx';
import React from 'react';

import {
  alignmentValues,
  backgroundColorValues,
  enableCarouselValues,
  fontFamilyValues,
  fontSizeValues,
  gridValues,
  isFlex,
  marginValues,
  paddingValues,
  verticalAlignmentValues,
} from './constants';
import type { SectionBlockProps } from './interfaces';

function SectionBlock({ config, children }: SectionBlockProps) {
  return (
    <section
      className={clsx(
        'section-block',
        config?.wrap ? 'flex-wrap' : 'flex-nowrap',
        config?.css_classes,
        config?.alignment && alignmentValues[config.alignment],
        config?.background_color && backgroundColorValues[config.background_color],
        enableCarouselValues[`${config?.enable_carousel ?? false}`],
        config?.font_family && fontFamilyValues[config.font_family],
        config?.font_size && fontSizeValues[config.font_size],
        config?.margin && marginValues[config.margin],
        config?.padding && paddingValues[config.padding],
        config?.layout && gridValues[config.layout],
        isFlex(config?.layout) &&
          config?.vertical_alignment &&
          verticalAlignmentValues[config.vertical_alignment]
      )}
    >
      {children}
    </section>
  );
}

export default SectionBlock;
